const pageType = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.pageType
setTimeout(()=>{
  if (typeof BSS_B2B !== "undefined" && pageType === "collection") {
    const qbTables = document.querySelectorAll(".bss-b2b-cart-item-qty-table");
    if (qbTables.length) {
      qbTables.forEach((qbTable)=>{
        const tableHeader = qbTable.querySelector(".bss-b2b-cart-item-qty-table-header");
        const tableWrapper = qbTable.querySelector(".bss-b2b-qty-table-wrapper");
        tableHeader.addEventListener("click",()=>{
          tableWrapper.style.display = tableWrapper.style.display === "none" ? "block" : "none";
        })
      }) 
    }
  }
},2000)